export default "__VITE_ASSET__BxO7u3HD__"